module.exports = __webpack_public_path__ + "static/media/ba.df9e32bf.svg";